<template>
  <wo-region v-if="company">
    <wo-layout>
      <wo-title tag-name="h3">{{ company.name }}</wo-title>
    </wo-layout>
    <wo-layout>
      <po-tabs :tabs="tabs" v-model="selectedTab" />
      <wo-spacer />
      <wo-region>
        <po-slot-switcher :value="selectedTab">

          <wo-grid slot="general">
            <wo-column width-lg="8">
              <user-list :filter="userFilter" titleKey="company.users">
                <po-action-dropdown slot="actions" :actions="actions" @execute="execute" mod-right />
              </user-list>
            </wo-column>
            <wo-column width-lg="4">
              <company-props :value="company">
                <po-route-link :value="editRoute" slot="actions" labelKey="general.action.edit" />
              </company-props>
              <wo-spacer />
              <address-props :value="company.address" :address-name="company.name" mod-props mod-map />
            </wo-column>
          </wo-grid>
          <company-account-list :filter="accountFilter" :company="company" slot="accounts" />
          <company-reference-list :filter="referenceFilter" :company="company" slot="references" />
          <company-user-permission-list :filter="permissionsFilter" :company="company" slot="permissions" />
        </po-slot-switcher>
      </wo-region>
    </wo-layout>
  </wo-region>
</template>

<script>

import { mapState } from 'vuex'
import { companyRepository } from '@/repository/company'

import { ADMIN_COMPANY_EDIT } from '@/routes/admin'

import UserList from '@/components/admin/UserList'
import CompanyProps from '@/components/admin/CompanyProps'
import AddressProps from '@/components/geography/AddressProps'
import CompanyAccountList from '@/components/admin/CompanyAccountList'
import CompanyReferenceList from '@/components/admin/CompanyReferenceList'
import CompanyUserPermissionList from '@/components/admin/CompanyUserPermissionList'
import CompanyMergeModal from '@/components/admin/CompanyMergeModal'

import { showModal } from '@/modal'

const mergeAction = { id: 'merge', labelKey: 'admin.company.action.merge', icon: 'merge' }

export default {
  components: { UserList, CompanyProps, CompanyAccountList, CompanyReferenceList, CompanyUserPermissionList, AddressProps },
  props: {
    companyId: [Number, String]
  },
  data () {
    return {
      selectedTab: undefined
    }
  },
  computed: mapState({
    company: state => state.company.company,
    editRoute () {
      return { name: ADMIN_COMPANY_EDIT }
    },
    userFilter () {
      return { company_id: this.companyId }
    },
    accountFilter () {
      return this.userFilter
    },
    referenceFilter () {
      return this.userFilter
    },
    permissionsFilter () {
      return this.userFilter
    },
    actions () {
      return [mergeAction]
    },
    tabs () {
      return [
        { labelKey: 'general.info', id: 'general' },
        { labelKey: 'admin.company.referencesTitle', id: 'references' },
        { labelKey: 'admin.company.accountsTitle', id: 'accounts' },
        { labelKey: 'admin.company.userPermissionsTitle', id: 'permissions' }
      ]
    }
  }),
  created () {
    this.loadCompany()
    this.selectedTab = this.tabs[0]
  },
  watch: {
    companyId () {
      this.loadCompany()
      this.selectedTab = this.tabs[0]
    }
  },
  methods: {
    loadCompany () {
      this.$store.dispatch(companyRepository.find, { id: this.companyId })
    },
    execute (action) {
      if (action === mergeAction) {
        showModal(CompanyMergeModal, { company: this.company })
          .then(this.loadCompany)
          .catch(e => {})
      }
    }
  }
}
</script>
